"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type GetTargetsRequest, type Target } from "@/generated/fastapi";
import { getTargets } from "../api/getTargets";
import { targetsKeys } from "./keys";

type UseTargetsQueryOptions = {
  initialData?: Target[];
  request?: GetTargetsRequest;
  enabled?: boolean;
};

export default function useTargetsQuery({
  initialData,
  request = {},
  enabled = true,
}: UseTargetsQueryOptions = {}) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: [...targetsKeys.list(), request],
    queryFn: () => getTargets(accessToken, request),
    enabled: Boolean(accessToken) && enabled,
    initialData,
  });
}
